import { queryOptions } from '@tanstack/vue-query'
import merge from 'lodash/merge'
import { queryClient } from '@/plugins/tanstack'
import { fetchUsersV3 } from '@/common/services/UsersService'
import { invalidateQuery, queryKeyFactory } from '@/common/services/serverData/serverDataManager'
import { SERVER_DATA_SCOPE, type GroupOptionsBase } from '@/common/types/cacheConstants'
import { type UserParamsDTOV3 } from '@/common/types/users'

interface GroupOptions extends GroupOptionsBase {
  params?: UserParamsDTOV3
}
function groupOptions(options: GroupOptions = {}) {
  const {
    params = {
      'include-deactivated': true,
    },
    ...config
  } = options
  const defaultConfig = {
    queryKey: queryKeyFactory({
      scope: SERVER_DATA_SCOPE.USERS,
      params,
    }),
    staleTime: Infinity,
    queryFn: () => {
      return fetchUsersV3(params['include-deactivated'], params.expand, params.include)
    },
  }
  return queryOptions(merge(defaultConfig, config))
}

async function fetch(options: GroupOptions = {}) {
  return queryClient.fetchQuery(groupOptions(options))
}

function invalidate() {
  invalidateQuery([
    queryKeyFactory({
      scope: SERVER_DATA_SCOPE.USERS,
    }),
  ])
}

export default {
  fetch,
  groupOptions,
  invalidate,
}
